import { lazy, Suspense, type ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { isNativePlatform } from 'services/auth/platform';
import { isMobileShellEnabled } from 'services/mobileShell';
import ClassicInstanceConnect from 'views/instance/InstanceConnect';

const MobileInstanceConnect = lazy(() => import('mobile/screens/InstanceConnect'));

/**
 * Gates the app behind instance selection on native.
 * The single native binary has no API host until the user picks an instance, so even the login screen is meaningless before then.
 * Web is always configured from the build-time env, so it renders children directly.
 */
const InstanceGate = ({ children }: { children: ReactNode }) => {
  const configured = useSelector((state: { instance?: { configured?: boolean } }) => state.instance?.configured);

  if (isNativePlatform() && !configured) {
    if (!isMobileShellEnabled()) return <ClassicInstanceConnect />;

    return (
      <Suspense fallback={null}>
        <MobileInstanceConnect />
      </Suspense>
    );
  }

  return <>{children}</>;
};

export default InstanceGate;
